import { EnvironmentProviders, Provider } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [
        AuthService,
        // You can add other auth-related providers here if needed
    ];
};
